"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionToGAActionMap = exports.LOGIN_MODAL_CATEGORY = exports.LOGIN_MODAL_ACCEPT_GA_ACTION = exports.LOGIN_MODAL_REJECT_GA_ACTION = exports.GDPR_REJECT_GA_ACTION = exports.GDPR_ACCEPT_GA_ACTION = exports.SHOW_GDPR_MODAL = exports.VIEW_ORGANIZER_ACTION = exports.UNFOLLOW_ORGANIZER_ACTION = exports.DISMISS_ORGANIZER_ACTION = exports.FOLLOW_ORGANIZER_ATTEMPT_ACTION = exports.FOLLOW_ORGANIZER_ACTION = void 0;
var FOLLOW_ORGANIZER_ACTION = 'FollowOrganizer';
exports.FOLLOW_ORGANIZER_ACTION = FOLLOW_ORGANIZER_ACTION;
var FOLLOW_ORGANIZER_ATTEMPT_ACTION = 'FollowAttempt';
exports.FOLLOW_ORGANIZER_ATTEMPT_ACTION = FOLLOW_ORGANIZER_ATTEMPT_ACTION;
var DISMISS_ORGANIZER_ACTION = 'OrganizerProfileCardDismissed';
exports.DISMISS_ORGANIZER_ACTION = DISMISS_ORGANIZER_ACTION;
var UNFOLLOW_ORGANIZER_ACTION = 'UnfollowOrganizer';
exports.UNFOLLOW_ORGANIZER_ACTION = UNFOLLOW_ORGANIZER_ACTION;
var VIEW_ORGANIZER_ACTION = 'OrganizerProfileCardClicked';
exports.VIEW_ORGANIZER_ACTION = VIEW_ORGANIZER_ACTION;
var SHOW_GDPR_MODAL = 'GDPRModalShown';
exports.SHOW_GDPR_MODAL = SHOW_GDPR_MODAL;
var GDPR_ACCEPT_GA_ACTION = 'FollowOrganizerGDPRAccept';
exports.GDPR_ACCEPT_GA_ACTION = GDPR_ACCEPT_GA_ACTION;
var GDPR_REJECT_GA_ACTION = 'FollowOrganizerGDPRReject';
exports.GDPR_REJECT_GA_ACTION = GDPR_REJECT_GA_ACTION;
var LOGIN_MODAL_REJECT_GA_ACTION = 'AbandonFollow';
exports.LOGIN_MODAL_REJECT_GA_ACTION = LOGIN_MODAL_REJECT_GA_ACTION;
var LOGIN_MODAL_ACCEPT_GA_ACTION = 'GetStarted';
exports.LOGIN_MODAL_ACCEPT_GA_ACTION = LOGIN_MODAL_ACCEPT_GA_ACTION;
var LOGIN_MODAL_CATEGORY = 'follow-prompt-modal';
exports.LOGIN_MODAL_CATEGORY = LOGIN_MODAL_CATEGORY;
var actionToGAActionMap = {
  followAttempt: FOLLOW_ORGANIZER_ATTEMPT_ACTION,
  unfollow: UNFOLLOW_ORGANIZER_ACTION,
  follow: FOLLOW_ORGANIZER_ACTION,
  gdprModal: SHOW_GDPR_MODAL,
  dismissOrganizer: DISMISS_ORGANIZER_ACTION,
  viewOrganizer: VIEW_ORGANIZER_ACTION
};
exports.actionToGAActionMap = actionToGAActionMap;
//# sourceMappingURL=googleAnalytics.js.map